import React from 'react';
import PropTypes from 'prop-types';

function MSText({ title, className, textColor, textAlign, fontWeight, style }) {
  return (
    <div className={`${className}`}>
      <p style={style} className={`${fontWeight} text-sm ${textColor} ${textAlign} letter-spacing-p leading-4`}>
        {title}
      </p>
    </div>
  );
}

export default MSText;

MSText.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string,
  fontWeight: PropTypes.string,
  style: PropTypes.any
};

MSText.defaultProps = {
  textColor: 'text-gray-300',
  textAlign: 'text-left',
  fontWeight: 'text-regular'
};
